import React, { useState } from 'react'
import { Alert } from 'reactstrap'

const UploadAlert = (props) => {
  const [visible, setVisible] = useState(true)
  const onDismiss = () => setVisible(false)

  return (
    <Alert
      style={{
        width: '50%',
        marginTop: '15px',
        marginBottom: '0px',
      }}
      color={props.color}
      isOpen={visible}
      toggle={onDismiss}
    >
      {props.children}
    </Alert>
  )
}

export default UploadAlert
